// extracted by mini-css-extract-plugin
module.exports = {"root":"vMxJj","title":"CC2vX","imgWrapper":"_2UjxQ","description":"gdPNO"};